const Config = {
    accept: 'image/*',
    multiple: false,
}

export default Config;